var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { staticClass: "login-layout" },
    [
      _c(
        "v-content",
        [
          _c(
            "v-container",
            {
              staticClass: "pb-0 pt-0",
              attrs: { fluid: "", "grid-list-xs": "", "fill-height": "" }
            },
            [
              _c(
                "v-layout",
                {
                  staticClass: "layout-row-login",
                  attrs: { row: "", "fill-height": "" }
                },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass: "login-background",
                      attrs: { md8: "", "hidden-sm-and-down": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            "fill-height": "",
                            row: "",
                            "justify-center": "",
                            "align-center": ""
                          }
                        },
                        [
                          _c("nuxt-link", { attrs: { to: "/" } }, [
                            _c("img", {
                              attrs: {
                                src: require("assets/images/img_logo_niubiz_on_primary.svg")
                              }
                            })
                          ]),
                          _c(
                            "div",
                            { staticClass: "fill-height white line ml-4 mr-4" },
                            [_vm._v(" ")]
                          ),
                          _c("div", { staticClass: "appname-text" }, [
                            _c(
                              "span",
                              { attrs: { slot: "name" }, slot: "name" },
                              [
                                _vm._v("GESTOR "),
                                _c("br"),
                                _vm._v(" DE AFILIACIÓN")
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      staticClass: "login-panel",
                      attrs: { md4: "", sm12: "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { "fill-height": "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm6: "",
                                "offset-sm3": "",
                                md8: "",
                                "offset-md2": "",
                                lg6: "",
                                "offset-lg3": ""
                              }
                            },
                            [
                              _c(
                                "v-layout",
                                {
                                  staticClass: "login-background movil",
                                  attrs: {
                                    xs12: "",
                                    sm6: "",
                                    "hidden-sm-and-up": "",
                                    row: "",
                                    "justify-center": "",
                                    "align-center": ""
                                  }
                                },
                                [
                                  _c("nuxt-link", { attrs: { to: "/" } }, [
                                    _c("img", {
                                      attrs: {
                                        src: require("assets/images/img_logo_niubiz_on_primary.svg")
                                      }
                                    })
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "fill-height white line ml-4 mr-4"
                                    },
                                    [_vm._v(" ")]
                                  ),
                                  _c("div", { staticClass: "appname-text" }, [
                                    _c(
                                      "span",
                                      { attrs: { slot: "name" }, slot: "name" },
                                      [
                                        _vm._v("GESTOR "),
                                        _c("br"),
                                        _vm._v(" DE AFILIACIÓN")
                                      ]
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    column: "",
                                    "fill-height": "",
                                    "align-center": "",
                                    "justify-center": ""
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "login-panel-box" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "login-panel-content" },
                                        [_c("nuxt")],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-333fd7da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-333fd7da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/login.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-333fd7da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/login.vue
// module chunks = 22